import { Button, ButtonProps } from './button';

export type SearchButtonProps = Omit<ButtonProps, 'icon' | 'iconClass' | 'iconPosition'>;

export const SearchButton = ({
  text = 'Search',
  variant = 'danger',
  size = 'sm',
  isLoading,
  ...rest
}: SearchButtonProps) => (
  <Button
    text={text}
    variant={variant}
    size={size}
    isLoading={isLoading}
    iconClass="fas fa-magnifying-glass"
    iconPosition="left"
    {...rest}
  />
);
